(function(){
    'use strict'

    angular
    .module('app.cantidadesDestajo')
    .controller('EditarCantidadDestajo', EditarCantidadDestajo);

    EditarCantidadDestajo.$inject = ['moment', '$q', '$scope', '$animationsSrv', '$routeParams','CantidadesDestajoService', 
    'logger', '$location', 'CantidadesService', 'EmpleadosService', 'TiposPlanillaService', 'CalendarizacionesService', 'UserInfoService'];

    function EditarCantidadDestajo(moment, $q, $scope, $animationsSrv, $routeParams, CantidadesDestajoService, 
        logger, $location, CantidadesService, EmpleadosService, TiposPlanillaService, CalendarizacionesService, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.tipos = [];
        vm.filterData = [];
        vm.empleados = [];

        vm.cantidadDestajo = {
            companiaId: UserInfoService.getCompaniaId(),
            id: $routeParams.id ? $routeParams.id : 0,
            calendarizacionId: $routeParams.planillaId,
            calendarizacionDesc: '',
            tipoCalendarizacionId: $routeParams.tipoPlanillaId,
            tipoCalendarizacionDesc: '',
            cantidadId: -1,
            fecha: moment().toDate(),
            empleadoId: '',
            empleadoNombre: '',
            cantidadCorte1: 0,
            cantidadCorte2: 0,
            cantidadCorte3: 0,
            cantidadCorte4: 0,
            cantidadCorte5: 0,
            cantidadCorte6: 0,
            cantidadCorte7: 0,
            cantidadCorte8: 0,
            cantidadCorte9: 0,
            cantidadCorte10: 0,
            totalCortes: 0
        };

        vm.busquedaEmpleado = {
            puestoId: -1,
            departamentoId: -1,
            tipoPlanillaId: -1,
            nombre: '',
            identificacion: '',
            companiaId: UserInfoService.getCompaniaId(),
            estado: -1
        };

        vm.openModalEmpleados = function(){
            if(vm.empleados.length > 0){
                $('#myModalEmpleados').modal('toggle');   
            }
            else{
                var promise = EmpleadosService.getAll(vm.busquedaEmpleado);

                promise
                .then(function(result){
                    vm.empleados = result.data;
                    $('#myModalEmpleados').modal('toggle'); 
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sessión ha terminado.');
                            break;
                    
                        default:
                            logger.error('Error al obtener los empleados.');
                            break;
                    }
                });
            }
             
        };

        vm.seleccionarEmpleado = function(e){
            vm.cantidadDestajo.empleadoId = e.id;
            vm.cantidadDestajo.empleadoNombre = e.nombre;
            $scope.cantidadDestajoForm.empleadoId.$dirty = true;
            $scope.cantidadDestajoForm.$dirty = true;
            $('#myModalEmpleados').modal('toggle');   
        };

        var promiseTipos = getTipos();
        var promiseTipoPlanilla = getTipoPlanilla();
        var promisePlanilla = getPlanilla();

        CargarCantidadesDestajo();

        function getTipos(){
            var promise = CantidadesService.getAllDestajo()
            .then(function(tipos){
                vm.tipos = tipos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos.');
            }); 
            
            return promise;
        };

        function getTipoPlanilla(){
            var promise = TiposPlanillaService.getById(vm.cantidadDestajo.companiaId, vm.cantidadDestajo.tipoCalendarizacionId)
            .then(function(tipoPlanilla){

                vm.cantidadDestajo.tipoCalendarizacionDesc = tipoPlanilla.descripcion;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de planilla.');
            }); 
            
            return promise;
        };

        function getPlanilla(){
            var promise = CalendarizacionesService.getById(vm.cantidadDestajo.companiaId, vm.cantidadDestajo.calendarizacionId)
            .then(function(planilla){

                vm.cantidadDestajo.calendarizacionDesc = 'Número: ' + planilla.numero + ' Del: ' + moment(planilla.fechaInicio).format('DD/MM/YYYY') + ' Hasta: ' + moment(planilla.fechaFinal).format('DD/MM/YYYY');
            })
            .catch(function(error){
                $logger.error('Error al obtener las planillas.');
            }); 
            
            return promise;
        };

        function CargarCantidadesDestajo(){
            $q.all([promiseTipos, promiseTipoPlanilla, promisePlanilla]).then(getCantidad);
        }

        function getCantidad(){

            if(vm.cantidadDestajo != 0){
                var promise = CantidadesDestajoService.getById(vm.cantidadDestajo.id);

                promise
                .then(function(cantidad){
                    vm.cantidadDestajo.empleadoId = cantidad.empleadoId;
                    vm.cantidadDestajo.fecha = moment(cantidad.fecha).toDate();
                    vm.cantidadDestajo.cantidadId = cantidad.cantidadId;
                    vm.cantidadDestajo.empleadoNombre = cantidad.empleadoNombre;
                    vm.cantidadDestajo.cantidadCorte1 = cantidad.cantidadCorte1;
                    vm.cantidadDestajo.cantidadCorte2 = cantidad.cantidadCorte2;
                    vm.cantidadDestajo.cantidadCorte3 = cantidad.cantidadCorte3;
                    vm.cantidadDestajo.cantidadCorte4 = cantidad.cantidadCorte4;
                    vm.cantidadDestajo.cantidadCorte5 = cantidad.cantidadCorte5;
                    vm.cantidadDestajo.cantidadCorte6 = cantidad.cantidadCorte6;
                    vm.cantidadDestajo.cantidadCorte7 = cantidad.cantidadCorte7;
                    vm.cantidadDestajo.cantidadCorte8 = cantidad.cantidadCorte8;
                    vm.cantidadDestajo.cantidadCorte9 = cantidad.cantidadCorte9;
                    vm.cantidadDestajo.cantidadCorte10 = cantidad.cantidadCorte10;
                    vm.cantidadDestajo.totalCortes = cantidad.totalCortes;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener la cantidad: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        function doFormValidations(){
            validateTipo();
        };

        function validateTipo(){
            if(vm.cantidadDestajo.cantidadId == -1){
                $scope.cantidadDestajoForm.cantidadId.$setValidity("different", false);
            }
            else{
                $scope.cantidadDestajoForm.cantidadId.$setValidity("different", true);
            }
        };

        vm.save = function(){

            $scope.submitted = true;

            doFormValidations();

            if($scope.cantidadDestajoForm.$valid){
                if(!vm.cantidadDestajo.id){
                    saveCantidad();
                }
                else if($scope.cantidadDestajoForm.$dirty){
                    updateCantidad();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveCantidad() {
            
            var promise = CantidadesDestajoService.save(vm.cantidadDestajo);
            
            promise
            .then(function(response){
                logger.success('Cantidad Destajo creada con éxito.');
                clearCantidadData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear la cantidad: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateCantidad(){

            var promise = CantidadesDestajoService.update(vm.cantidadDestajo);
            
            promise
            .then(function(response){
                logger.success('Cantidad modificada con éxito.');
                $location.path('/cantidades-destajo');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar la cantidad: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearCantidadData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.cantidadDestajo = {
                companiaId: UserInfoService.getCompaniaId(),
                id: $routeParams.id ? $routeParams.id : 0,
                calendarizacionId: $routeParams.planillaId,
                calendarizacionDesc: vm.cantidadDestajo.calendarizacionDesc,
                tipoCalendarizacionId: $routeParams.tipoPlanillaId,
                tipoCalendarizacionDesc: vm.cantidadDestajo.tipoCalendarizacionDesc,
                cantidadId: -1,
                fecha: moment().toDate(),
                empleadoId: '',
                empleadoNombre: '',
                cantidadCorte1: 0,
                cantidadCorte2: 0,
                cantidadCorte3: 0,
                cantidadCorte4: 0,
                cantidadCorte5: 0,
                cantidadCorte6: 0,
                cantidadCorte7: 0,
                cantidadCorte8: 0,
                cantidadCorte9: 0,
                cantidadCorte10: 0,
                totalCortes: 0
            };
            // Set back to pristine.
            $scope.cantidadDestajoForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.cantidadDestajoForm.$setUntouched();
        };

        vm.tiposChange = function(){
            validateTipo();
        };

        vm.filterEmpleados = function(){
            vm.filterData = vm.empleados.filter(function(g) {
                return (g.id.toString().indexOf(vm.busquedaEmpleado.id) >= 0 || !vm.busquedaEmpleado.id) && 
                (g.nombre.toLowerCase().indexOf(vm.busquedaEmpleado.nombre.toLowerCase()) >= 0 || !vm.busquedaEmpleado.nombre);
            }).slice(0, 100);
        };

        vm.fechaOptions = {
            showWeeks: true
        };

        vm.openFecha = function(){
            vm.fechaOpened = !vm.fechaOpened;
        };

    }
})();